module.exports = __webpack_public_path__ + "img/product-after-sale-building-bg-icon.042a66a7.png";